import {Facebook} from 'styled-icons/feather/Facebook'
import {Instagram} from 'styled-icons/feather/Instagram'
import {Linkedin} from 'styled-icons/feather/Linkedin'
import {Whatsapp} from 'styled-icons/boxicons-logos/Whatsapp'

export default {
    Facebook,
    Instagram,
    Linkedin,
    Whatsapp
}